import React, { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import { Button } from "../layer/wrapper";
import { getDetailSegment } from "utils/buro";
import _ from "lodash";
import { getFilterLoanBuro } from "../BuroMainTwo";
import { calReportAging } from "../../../utils/calReportAging";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function ReportNCB({
  loan = [],
  buroDate = new Date(),
  loanNotCal = [],
  interest,
  loanLastPaymentDone = [],
}) {
  const [loading, setLoading] = useState(false);
  const [buro, setBuro] = useState([]);
  const [countExport, setCountExport] = useState(0);

  useEffect(() => {
    if (buro.length > 0) {
      const getExportId = document.getElementById("export-excel-ncb");
      getExportId.click();
    }
  }, [buro]);

  const onClickAging = async () => {
    try {
      setLoading(true);

      let { dataPrinciple: newLoan } = calReportAging(loan, buroDate);
      newLoan = newLoan.filter((loan) => {
        if (loan.loan_id) {
          return loan;
        }
      });
      let filterLoan = _.cloneDeep(
        getFilterLoanBuro(newLoan, buroDate, interest)
      );
      let dataExport = _.cloneDeep([...filterLoan, ...loanLastPaymentDone]);
      let newBuro = getDetailSegment({
        dataExport,
        currentDate: new Date(buroDate),
        logType: "LIST_ALL",
        showLog: true,
      });

      newBuro = newBuro.map((item) => {
        const findLoanNotCal = loanNotCal.find(
          (loan) => loan?.loan_kbank_id === item?.accountNumber?.value
        );

        let checkNewInstallment =
          findLoanNotCal?.installments[findLoanNotCal?.installments.length - 1]
            ?.isNewInstallment || false;

        if (findLoanNotCal) {
          return {
            ...item,
            capitalRemain: findLoanNotCal.capitalRemain || "0",
            ReCapitalRemain: item.capitalRemain || "0",
            checkNewInstallment,
          };
        }

        return { ...item, checkNewInstallment };
      });

      setBuro(newBuro);
      setCountExport(newBuro.length);
    } catch (error) {
      console.log("loading error", error);
    } finally {
      setLoading(false);
    }
  };

  const borders = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  const createDataWithStyle = (data = []) => {
    var result = [];

    var filled = { fgColor: { rgb: "FFFFFF" } };
    var filled_col_0 = { patternType: "solid", fgColor: { rgb: "FDFFA7" } };
    const style = {
      font: { sz: 14 },
      alignment: "right",
      borders,
      fill: filled,
    };

    for (let i = 0; i < data.length; i++) {
      // let myAddress = data[i]?.address_1?.value;

      // if (data[i]?.address_2?.value) {
      //   myAddress += " " + data[i]?.address_2?.value;
      // }

      result.push([
        {
          value: `${data[i]?.accountNumber?.value || ""}`,
          // title: "AccountNumber",
          style,
        },
        {
          value: `${data[i]?.accountStatus?.value || ""}`,
          title: "AccountStatus",
          style,
        },
        {
          value: `${data[i]?.accountType?.value || ""}`,
          title: "AccountType",
          style,
        },
        {
          value: `${data[i]?.address_1?.value || ""}`,
          // title: "Address",
          style,
        },
        {
          value: `${data[i]?.address_2?.value || ""}`,
          // title: "Address",
          style,
        },
        {
          value: `${data[i]?.address_3?.value || ""}`,
          // title: "Address",
          style,
        },
        {
          value: `${data[i]?.amountOwed?.value || ""}`,
          // title: "AmountOwed",
          style,
        },
        {
          value: `${data[i]?.amountPastDue?.value || ""}`,
          // title: "AmountPastDue",
          style,
        },
        {
          value: `${data[i]?.country?.value || ""}`,
          // title: "Country",
          style,
        },
        {
          value: `${data[i]?.currencyCode?.value || ""}`,
          // title: "CurrencyCode",
          style,
        },
        {
          value: `${data[i]?.customerType?.value || ""}`,
          // title: "CustomerType",
          style,
        },
        {
          value: `${data[i]?.dateAccountClosed?.value || ""}`,
          // title: "DateAccountClosed",
          style,
        },
        {
          value: `${data[i]?.dateAccountOpened?.value || ""}`,
          // title: "DateAccountOpened",
          style,
        },
        {
          value: `${data[i]?.dateOfBirth?.value || ""}`,
          // title: "DateOfBirth",
          style,
        },
        {
          value: `${data[i]?.dateOfLastDebt?.value || ""}`,
          // title: "DateOfLastDebt",
          style,
        },
        {
          value: `${data[i]?.dateOfLastPayment?.value || ""}`,
          // title: "DateOfLastPayment",
          style,
        },
        {
          value: `${data[i]?.defaultDate?.value || ""}`,
          // title: "DefaultDate",
          style,
        },
        {
          value: `${data[i]?.familyName?.value || ""}`,
          // title: "FamilyName",
          style,
        },
        {
          value: `${data[i]?.firstName?.value || ""}`,
          // title: "FirstName",
          style,
        },
        {
          value: `${data[i]?.idNumber?.value || ""}`,
          // title: "IdNumber",
          style,
        },
        {
          value: `${data[i]?.idSegmentTag?.value || ""}`,
          // title: "IdSegmentTag",
          style,
        },
        {
          value: `${data[i]?.idType?.value || ""}`,
          // title: "idType",
          style,
        },
        {
          value: `${data[i]?.installmentAmount?.value || ""}`,
          // title: "InstallmentAmount",
          style,
        },
        {
          value: `${data[i]?.installmentFrequency?.value || ""}`,
          // title: "InstallmentFrequency",
          style,
        },
        {
          value: `${data[i]?.installmentNumberOfPayment?.value || ""}`,
          // title: "InstallmentNumberOfPayment",
          style,
        },
        {
          value: `${data[i]?.loanAmount?.value || ""}`,
          // title: "LoanAmount",
          style,
        },
        {
          value: `${data[i]?.memberCode?.value || ""}`,
          // title: "MemberCode",
          style,
        },
        {
          value: `${data[i]?.memberName?.value || ""}`,
          // title: "MemberName",
          style,
        },
        {
          value: `${data[i]?.numberOfCoBorrower?.value || ""}`,
          // title: "NumberOfCoBorrower",
          style,
        },
        {
          value: `${data[i]?.numberOfDate?.value || ""}`,
          // title: "NumberOfDate",
          style,
        },
        {
          value: `${data[i]?.ownershipIndicator?.value || ""}`,
          // title: "OwnershipIndicator",
          style,
        },
        {
          value: `${data[i]?.paSegmentTag?.value || ""}`,
          // title: "PaSegmentTag",
          style,
        },
        {
          value: `${data[i]?.pnSegmentTag?.value || ""}`,
          // title: "PnSegmentTag",
          style,
        },
        {
          value: `${data[i]?.tlSegmentTag?.value || ""}`,
          // title: "TlSegmentTag",
          style,
        },
        {
          value: `${data[i]?.capitalRemain || "0"}`,
          // title: "TlSegmentTag",
          style,
        },
        {
          value: `${data[i]?.ReCapitalRemain || "0"}`,
          // title: "TlSegmentTag",
          style,
        },
        // {
        //   value: `${data[i]?.checkNewInstallment}`,
        //   // title: "TlSegmentTag",
        //   style,
        // },
      ]);
    }
    return result;
  };

  const sameObj = {
    borders,
    width: { wch: 12 },
    style: { fill: { patternType: "solid", fgColor: { rgb: "4287f5" } } },
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "AccountNumber",
          ...sameObj,
        },
        {
          title: "AccountStatus",
          ...sameObj,
        },
        {
          title: "AccountType",
          ...sameObj,
        },
        {
          title: "Address 1",
          ...sameObj,
        },
        {
          title: "Address 2",
          ...sameObj,
        },
        {
          title: "Address 3",
          ...sameObj,
        },
        {
          title: "AmountOwed",
          ...sameObj,
        },
        {
          title: "AmountPastDue",
          ...sameObj,
        },
        {
          title: "Country",
          ...sameObj,
        },
        {
          title: "CurrencyCode",
          ...sameObj,
        },
        {
          title: "CustomerType",
          ...sameObj,
        },
        {
          title: "DateAccountClosed",
          ...sameObj,
        },
        {
          title: "DateAccountOpened",
          ...sameObj,
        },
        {
          title: "DateOfBirth",
          ...sameObj,
        },
        {
          title: "DateOfLastDebt",
          ...sameObj,
        },
        {
          title: "DateOfLastPayment",
          ...sameObj,
        },
        {
          title: "DefaultDate",
          ...sameObj,
        },
        {
          title: "FamilyName",
          ...sameObj,
        },
        {
          title: "FirstName",
          ...sameObj,
        },
        {
          title: "IdNumber",
          ...sameObj,
        },
        {
          title: "IdSegmentTag",
          ...sameObj,
        },
        {
          title: "idType",
          ...sameObj,
        },
        {
          title: "InstallmentAmount",
          ...sameObj,
        },
        {
          title: "InstallmentFrequency",
          ...sameObj,
        },
        {
          title: "InstallmentNumberOfPayment",
          ...sameObj,
        },
        {
          title: "LoanAmount",
          ...sameObj,
        },
        {
          title: "MemberCode",
          ...sameObj,
        },
        {
          title: "MemberName",
          ...sameObj,
        },
        {
          title: "NumberOfCoBorrower",
          ...sameObj,
        },
        {
          title: "NumberOfDate",
          ...sameObj,
        },
        {
          title: "OwnershipIndicator",
          ...sameObj,
        },
        {
          title: "PaSegmentTag",
          ...sameObj,
        },
        {
          title: "PnSegmentTag",
          ...sameObj,
        },
        {
          title: "TlSegmentTag",
          ...sameObj,
        },
        {
          title: "CapitalRemain",
          ...sameObj,
        },
        {
          title: "ReCapitalRemain",
          ...sameObj,
        },
        // {
        //   title: "NewInstallment",
        //   ...sameObj,
        // },
      ],
      data: createDataWithStyle(buro),
    },
  ];

  return (
    <div>
      <ExcelFile
        filename={`REPORT_NCB_${format(new Date(buroDate), "yyyy-MM-dd")}`}
        element={<button id="export-excel-ncb" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="NCB"></ExcelSheet>
      </ExcelFile>
      <Button disabled={loading || !loan.length} onClick={onClickAging}>
        {countExport > 0 &&
          `${countExport}${
            loanLastPaymentDone && ` + ${loanLastPaymentDone.length}`
          }`}{" "}
        Report NCB
      </Button>
    </div>
  );
}

export default ReportNCB;
